define("shared/helpers/html-safe", ["exports", "@ember/component/helper", "@ember/template"], function (_exports, _helper, _template) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"@ember/template"eaimeta@70e063a35619d71f
  function htmlSafeHelper(value) {
    return (0, _template.htmlSafe)(value);
  }
  var _default = _exports.default = (0, _helper.helper)(htmlSafeHelper);
});